import { createSlice } from "@reduxjs/toolkit";
import {
  AddHolidayAction,
  DeleteHolidayAction,
  GetAllHolidayAction,
  UpdateHolidayAction,
} from "store/middlewares/dataManagement/holiday";

export const holidaySlice = createSlice({
  name: "holiday",
  initialState: {
    holidayLoading: false,
    holiday: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllHolidayAction.pending, (state) => {
        state.holidayLoading = state.holiday?.data.length > 0 ? false : true;
        state.holiday = state.holiday?.data.length > 0 ? state.holiday : null;
      })

      .addCase(GetAllHolidayAction.fulfilled, (state, action) => {
        state.holidayLoading = false;   
        state.holiday = action.payload.response;
      })

      .addCase(GetAllHolidayAction.rejected, (state) => {
        state.holidayLoading = false;
        state.holiday = null;
      })

      // add holiday
      .addCase(AddHolidayAction.fulfilled, (state, action) => {
        state.holidayLoading = false;   
        state.holiday = action.payload.response;
      })
      // Update Holiday
      .addCase(UpdateHolidayAction.fulfilled, (state, action) => {
        state.holidayLoading = false;
        state.holiday = {
          ...state.holiday,
          data: state.holiday.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      .addCase(DeleteHolidayAction.fulfilled, (state, action) => {
         state.holidayLoading = false;   
        state.holiday = action.payload.response;
       
      })
  },
});
export default holidaySlice.reducer;
